import { useMutation, useQuery } from '@apollo/client';
import { GET_CUSTOMER } from '../graphql/queries';
import { UPDATE_CUSTOMER } from '../graphql/mutations/customer';

export const useCustomer = () => {
  const { data: customerData, loading: customerLoading, error: customerError, refetch: refetchCustomer } = useQuery(GET_CUSTOMER);

  const [updateCustomer, { loading: updateLoading, error: updateError }] = useMutation(UPDATE_CUSTOMER, {
    onCompleted: (data) => {
      if (data?.updateCustomer) {
        console.log('Customer updated successfully:', data.updateCustomer);
      }
    },
    onError: (error) => {
      console.error('Error updating customer:', error.message);
    },
  });

  const updateCustomerData = async (customerData: {
    termsOfUse?: string;
    privacyPolicy?: string;
    emailVerificationAcceptedTitle?: string;
    emailVerificationAcceptedFromName?: string;
    emailVerificationAcceptedContent?: string;
    emailVerificationCompletedTitle?: string;
    emailVerificationCompletedFromName?: string;
    emailVerificationCompletedContent?: string;
  }) => {
    try {
      await updateCustomer({
        variables: customerData,
      });
    } catch (error) {
      console.error('Error updating customer information:', error);
      throw error;
    }
  };

  return {
    customerData: customerData?.getCustomer,
    loading: customerLoading || updateLoading,
    error: customerError || updateError,
    updateCustomer: updateCustomerData,
    refetchCustomer,
  };
};
